var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModifyh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8594 0.640575C16.4492 0.230418 15.8928 0 15.3127 0C14.7326 0 14.1763 0.230418 13.766 0.640575L12.8019 1.60474L15.8952 4.69807L16.8594 3.73391C17.2695 3.32368 17.5 2.76734 17.5 2.18724C17.5 1.60714 17.2695 1.0508 16.8594 0.640575ZM15.011 5.58224L11.9177 2.48891L1.79271 12.6139C1.27842 13.1279 0.90036 13.7621 0.692712 14.4589L0.0260455 16.6964C-0.00614105 16.8044 -0.00854162 16.919 0.0190979 17.0283C0.0467374 17.1375 0.103389 17.2372 0.183058 17.3169C0.262728 17.3966 0.362451 17.4532 0.471678 17.4809C0.580905 17.5085 0.695571 17.5061 0.803545 17.4739L3.04105 16.8072C3.7379 16.5996 4.37201 16.2215 4.88605 15.7072L15.011 5.58224Z",
    fill: "#EB4646",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifyh);
export default __webpack_public_path__ + "static/media/modifyh.24e89b5f95d5bf01754d0fbf7c707c1f.svg";
export { ForwardRef as ReactComponent };